import { createSelector } from "reselect";
import _ from "lodash";
import moment from "moment";
export const selectAllReports = ({ HolidayRequestManager_reducer }) => {
    return HolidayRequestManager_reducer.reports;
};
export const getRequesting = ({ HolidayRequestManager_reducer }) => {
    return HolidayRequestManager_reducer.requesting;
};
export const selectConfig = ({ MainReducer }) => {
    if (MainReducer.config) return MainReducer.config;
    else return false;
};
export const selectProfile = ({ UserProfile_reducer }) => {
    if (UserProfile_reducer.profile) return UserProfile_reducer.profile.profile;
    else return false;
};
export const selectPermissions = createSelector(
    [selectConfig, selectProfile],
    (config = false, { access_level = false }) => {
        if (access_level && config) {
            return config[access_level]["holiday_request"];
        } else return true;
    }
);
export const selectAllHolidayRequests = createSelector(
    [selectAllReports],
    (reports = false) => {
        if (reports) {
            let holidayRequestsPerUser = _.flatten(
                _.compact(
                    Object.keys(reports).map(uid => {
                        return (
                            _.get(reports[uid], "reports.holiday_request") ||
                            null
                        );
                    })
                )
            );
            let totalHolidayRequestsFlattened = holidayRequestsPerUser.map(
                requests => {
                    return Object.keys(requests).map(timestamp => {
                        return requests[timestamp];
                    });
                }
            );
            totalHolidayRequestsFlattened = totalHolidayRequestsFlattened
                .flat()
                .sort((a, b) => {
                    a = new moment(a.timestamp, "DD/MM/YYYY HH:mm:ss"); //.format("DD/MM/YYYY hh:mm:ss");
                    b = new moment(b.timestamp, "DD/MM/YYYY HH:mm:ss"); //.format("DD/MM/YYYY hh:mm:ss");
                    return b.diff(a);
                });
            return totalHolidayRequestsFlattened.flat();
        } else {
            return false;
        }
    }
);
export const selectRowsPerPage = ({ HolidayRequestManager_reducer }) => {
    return HolidayRequestManager_reducer.rowsPerPage;
};
export const selectPage = ({ HolidayRequestManager_reducer }) => {
    return HolidayRequestManager_reducer.page;
};
